<template>
  <div>
    <div v-if="$store.state.user.clientID" :key="$root.time">
      <h1 class="main-heading">Waste</h1>
      <SectionNavigator
        category="travel-and-transport"
        :sections="$root.waste.sections"
        :schemas="$root.waste.schemas"
      />
      <router-view />
    </div>
  </div>
</template>

<script>
import SectionNavigator from '../SectionNavigator'

// import routes from '../../router/index'
export default {
  name: 'category-waste',
  props: { sections: String, schemas: Array },
  components: {
    SectionNavigator
  }
}
</script>
